(ns teamoesterreich.admin-mode.ui-helper.are-you-sure-modal
  (:require ["react-virtualized" :as rv]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.done :refer [done]]
            [reagent-material-ui.icons.keyboard-arrow-left  :refer [keyboard-arrow-left]]
            ))


(defn are-you-sure-modal [!show message ok-message on-ok-fn &[on-cancel-fn]]

  [mui/modal
   {
    :aria-labelledby "simple-modal-title"
    :aria-describedby "simple-modal-description"
    :style {:display "flex"
            :marginRight "auto"
            :marginLeft "auto"
            :alignItems "center"
            :justifyContent "center"}
    :open (if @!show true false)

    }
   [:div
    {
     :class "modal"
     :style {:width 600}}
    [:h4  message]

    [:br]
    [:br]
    [mui/button
     {:color "primary"
      :variant "contained"
      :startIcon (r/as-element [keyboard-arrow-left])
      :style #js {:marginRight 50}
      :onClick (fn []
                 (if on-cancel-fn
                   (on-cancel-fn)
                   (reset! !show false)))
      }
     "Abbrechen"]
    [mui/button
     {:style #js {:float "right" }
      :variant "contained"
      :startIcon (r/as-element [done])
      :onClick (fn []
                 (on-ok-fn @!show)
                 (reset! !show false))
      }
     ok-message]]
   ]
  )


